module.exports = __webpack_public_path__ + "static/img/goalkeeper.54164f71.svg";